import { IBotonAccionCabeceraTabla } from "@appNeo/neoShared/services/tabla/tabla.service";

export enum TiposPrecioExtra {
  Fijo = '7100001',
  Unitario = '7100002'
}
export enum TiposPrecioExtraIcon {
  Fijo = 'icon-20 icon-ibm-currency_euro',
  Unitario = 'icon-20 icon-ibm-calculation-alt'
}
export enum TiposExtra {
  Paquete = '8100001',
  Menu = '8100002'
}
export enum TiposExtraIcon {
  Paquete = 'icon-20 icon-ibm-gift',
  Menu = 'icon-20 icon-ibm-restaurant'
}
export const MAXIMO_NINOS = 50;

export enum TiposTurnosColorEnum {
    Mañana = 'FFE62E',
    Tarde = '14A14D',
    Noche = '6A8DFF',
    MañanaFestivo = '2100004',
    TardeFestivo = '14A14D',
    NocheFestivo = '6A8DFF',
    MañanaPreFestivo = 'FFE62E',
    TardePreFestivo = '14A14D',
    NochePreFestivo = '6A8DFF',
}
export enum IdTiposTurnosEnum {
    Mañana = '2100001',
    Tarde = '2100002',
    Noche = '2100003',
    MañanaFestivo = '2100007',
    TardeFestivo = '2100008',
    NocheFestivo = '2100009',
    MañanaPreFestivo = '2100004',
    TardePreFestivo = '2100005',
    NochePreFestivo = '2100006',
}
export enum NombreTiposTurnosEnum {
    Mañana = 'Mañana',
    Tarde = 'Tarde',
    Noche = 'Noche',
    MañanaFestivo = 'M-Festivo',
    TardeFestivo = 'T-Festivo',
    NocheFestivo = 'N-Festivo',
    MañanaPreFestivo = 'M-PreFestivo',
    TardePreFestivo = 'T-Prefestivo',
    NochePreFestivo = 'N-Prefestivo',
}
export enum TiposMenuEnum {
    Ninos = '1100002',
    Padres = '1100001',
}

export enum TiposAgrupacionExtraEnum {
  Tarta = '3100001',
  Otros = '3100002'
}

export const mapaDias = {
  L: 1,
  M: 2,
  X: 3,
  J: 4,
  V: 5,
  S: 6,
  D: 7
};
export const DIASSEMANA = [
  '', // índice 0 no se usa
  'L',
  'M',
  'X',
  'J',
  'V',
  'S',
  'D'
];
export const DIASSEMANAEXTENSO = [
  '', // índice 0 no se usa
  'Lunes',
  'Martes',
  'Miércoles',
  'Jueves',
  'Viernes',
  'Sábado',
  'Domingo'
];

export const ESTADOS_ICONOS = [
  {id:'idZona', icono: 'icon-ibm-map_boundary'},
  {id:'idTipoTurno', icono: 'icon-ibm--time'},
  {id:'idIva', icono: 'icon-ibm-percentage'},
  {id:'idTipoAgrupacion', icono: 'icon-ibm-box'},
  {id:'idPaquete', icono: 'icon-ibm-magic_wand'},  
];

export const TITLE_PAGE: string = 'SPRING OCIO';
 
export const  TITLE_PAGE_COMPOSE: string = 'Admin Spring Ocio';

  // TABLA
export const  NUMERO_ROWS_CELDA_EDITABLE_INICIAL: number = 1;
export const  NUMERO_ROWS_CELDA_EDITABLE_FOCUS: number = 30;
  // PAGINADOR
export const  PAGINADOR_LABEL_ELEMENTOS: string = 'Elementos por página';
export const  PAGINADOR_LABEL_ANTERIOR: string = 'Página anterior';
export const  PAGINADOR_LABEL_SIGUIENTE: string = 'Página siguiente';
export const  PAGINADOR_LABEL_PRIMERA: string = 'Primera página';
export const  PAGINADOR_LABEL_ULTIMA: string = 'Última página';
export const  DESCRIPCIONMETADEFECTO: string =  'Spring';

export const RUTA_PADRE_ADMIN: string = '/';

export const FORMAT_FECHA_API : string = 'dd/MM/yyyy';

export const BOTON_DESCARGA_EXCEL: IBotonAccionCabeceraTabla =
    {
      id: 'btn-descargaExcel',
      botonStroked: true,
      color: '',
      bloqueClass: 'btn-add',
      mostrarBtnLg: true,
      neoButtonClassLg: 'btn-crear-lg',
      // iconClassLg: 'icon-16 icon-ibm--file-download',
      iconClassLg: 'icon-16 icon-ibm-XLS',
      neoButtonInputClassLg: 'btn-sm',
      mostrarBtnXs: true,
      texto: 'Descarga excel',
      textoLg: 'Descarga excel',
      neoButtonClassXs: 'btn-crear-xs',
      // iconClassXs: 'icon-16 icon-ibm--file-download',
      iconClassXs: 'icon-16 icon-ibm-XLS',
      neoButtonInputClassXs: 'btn-sm',
      textoXs: '',
    };

export const OPCIONES_FILTRO_ESTADO_ACTIVO = [{id:1, nombre: 'Sí'}, {id: 0, nombre: 'No'}];

export const CODIGO_IDIOMA_DEFECTO = 'es';
export const IDIOMA_DEFECTO= 1;

export const GLOBAL_CONFIG = {
  booleanKeysConvertibles: ['activo', 'reservable', 'activa', 'checkIn'],
  // puedes añadir más configuraciones aquí si lo necesitas
};

export const ID_ZONA_DEFAULT = '2';

export const CONCEPTO_FACTURA_EVENTO = "Evento ";

export const DESCRIPCION_RECTIFICAR_FACTURA = "Rectificación";

export const DESCRIPCION_RECTIFICAR_CERO_FACTURA = "Rectificación a importe 0€";

export const TEXTO_FIANZA_ANTICIPO = "Anticipo";
export const TEXTO_FIANZA = "Fianza";
export const PAQUETE_ALQUILER = "7";